<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  #app {
    min-height: 100vh;
    min-height: -webkit-fill-available; /* iOS Safari 适配 */
  }

  body {
    min-height: 100vh;
    min-height: -webkit-fill-available; /* iOS Safari 适配 */
  }
}
</style>
